import language from '@/plugins/language';

export default class CoreLanguage {
  constructor(parent) {
    this.$parent = parent;
    this.$data = language;
    this.promise = null;
  }

  set(key) {
    this.promise = new Promise((resolve) => {
      this.$parent.show = false;
      this.$data.download(key)
        .then(() => {
          this.$data.value = key;
        })
        .finally(() => {
          this.$parent.show = true;
          this.$parent.title.set();
          resolve();
        });
    });
    return this.promise;
  }

  get(key) {
    return this.$data.get(key);
  }
}
